/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/content_cards" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appsAppGroupIdChartsContentCards } from "./constants";
import type { ChartsContentCardsResult } from "./types";

export const getChartsContentCards = reactQueryFetcherAdapter(
  appsAppGroupIdChartsContentCards,
  (
    signal: AbortSignal,
    appGroupId: string,
    startDate: number,
    endDate: number
  ): Promise<ChartsContentCardsResult> => {
    return fetch(
      `/apps/${appGroupId}/charts/content_cards`,
      "GET",
      {
        start_date: startDate,
        end_date: endDate,
      },
      { signal }
    );
  }
);
